/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconInnerShadowTopLeft = createReactComponent(
  "inner-shadow-top-left",
  "IconInnerShadowTopLeft",
  [
    ["path", { d: "M12 3a9 9 0 1 1 0 18a9 9 0 0 1 0 -18z", key: "svg-0" }],
    ["path", { d: "M6 12a6 6 0 0 1 6 -6", key: "svg-1" }]
  ]
);

export { IconInnerShadowTopLeft as default };
//# sourceMappingURL=IconInnerShadowTopLeft.js.map
